import SupplierFormPopup from "./SupplierFormPopup";

export default function AddSupplierPopup({ isOpen, onClose, onAdded, onPending, businessUnitId, initialValues, requestClient, requiredUsage }) {
  return isOpen ? <SupplierFormPopup key={businessUnitId || "new"} businessUnitId={businessUnitId} initialValues={initialValues}
    requestClient={requestClient} requiredUsage={requiredUsage} onClose={onClose} onSaved={onAdded} onPending={onPending} /> : null;
}
